import travelClient from './travelClient';
import { travelEndpoints } from './endpoints';

/**
 * D5 處理協議 API：只包裝既有 8 個後端端點（查詢、建立、修訂、送出、本人確認、本人拒絕、撤回）。
 * 沒有任何執行款項、退款或轉帳的端點。
 */

const SCALAR_ID_KEYS = [
  'proposalId', 'groupTripId', 'caseId', 'bookingId', 'creatorMemberId', 'consequenceId',
  'principalMemberId', 'principalTravelerId', 'memberId', 'travelerId', 'beneficiaryId', 'rowVersion',
];
const ID_ARRAY_KEYS = ['affectedTravelerIds', 'consequenceIds'];

const SCALAR_ID_PATTERN = new RegExp(`("(?:${SCALAR_ID_KEYS.join('|')})"\\s*:\\s*)(-?\\d+)(?=\\s*[,}\\]])`, 'g');
const ID_ARRAY_PATTERN = new RegExp(`("(?:${ID_ARRAY_KEYS.join('|')})"\\s*:\\s*\\[)(\\s*\\d+(?:\\s*,\\s*\\d+)*\\s*)(\\])`, 'g');

/**
 * 防禦性解析：後端契約已以字串輸出 Long，此處在 JSON.parse 前再把白名單 ID 與 rowVersion 數字 token 轉成字串，
 * 確保超過 2^53 的值不經過 JavaScript Number。金額欄位本來就是字串，不做任何轉換。
 */
export function parseSettlementJson(raw) {
  if (typeof raw !== 'string' || !raw) return raw;
  const textBody = raw
    .replace(SCALAR_ID_PATTERN, '$1"$2"')
    .replace(ID_ARRAY_PATTERN, (match, head, members, tail) => `${head}${members.replace(/\d+/g, '"$&"')}${tail}`);
  return JSON.parse(textBody);
}

const json = { transformResponse: [parseSettlementJson] };
const withKey = (idempotencyKey) => ({ ...json, headers: { 'Idempotency-Key': idempotencyKey } });
const versioned = ({ expectedRowVersion, expectedGeneration }) => ({ expectedRowVersion, expectedGeneration });

export const settlementApi = {
  list: (groupTripId) => travelClient.get(travelEndpoints.groupTripSettlementProposals(groupTripId), json),
  get: (groupTripId, proposalId) => travelClient.get(
    travelEndpoints.groupTripSettlementProposal(groupTripId, proposalId), json,
  ),
  create: (groupTripId, { caseId, bookingId, consequences }, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripSettlementProposals(groupTripId),
    { caseId, bookingId, consequences }, withKey(idempotencyKey),
  ),
  revise: (groupTripId, proposalId, { expectedRowVersion, expectedGeneration, consequences }, idempotencyKey) => (
    travelClient.post(
      travelEndpoints.groupTripSettlementProposalAction(groupTripId, proposalId, 'revisions'),
      { expectedRowVersion, expectedGeneration, consequences }, withKey(idempotencyKey),
    )
  ),
  submit: (groupTripId, proposalId, versions, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripSettlementProposalAction(groupTripId, proposalId, 'submit'),
    versioned(versions), withKey(idempotencyKey),
  ),
  /** 本人確認：本文不含任何 memberId，操作者一律由登入身分決定。 */
  confirm: (groupTripId, proposalId, versions, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripSettlementProposalAction(groupTripId, proposalId, 'confirmations'),
    versioned(versions), withKey(idempotencyKey),
  ),
  reject: (groupTripId, proposalId, versions, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripSettlementProposalAction(groupTripId, proposalId, 'rejections'),
    versioned(versions), withKey(idempotencyKey),
  ),
  withdraw: (groupTripId, proposalId, versions, idempotencyKey) => travelClient.post(
    travelEndpoints.groupTripSettlementProposalAction(groupTripId, proposalId, 'withdraw'),
    versioned(versions), withKey(idempotencyKey),
  ),
};
